import { useQuery } from '@tanstack/react-query';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../api/client';

type AvailablePointsResponse = {
  success: boolean;
  message: string;
  data: {
    user_id: string;
    available_points: number;
  };
  statusCode: number;
};

const RewardPointsSection: React.FC = () => {
  const navigate = useNavigate();

  const { data } = useQuery<AvailablePointsResponse>({
    queryKey: ["getAyeFacePoints"],
    queryFn: async () => {
      const resp = await apiClient.get('/available-points');
      return resp.data;
    },
  });

  const { available_points } = data?.data || {};

  return (
    <div className="mx-auto mt-8 max-w-full px-4 pb-6 sm:px-6 lg:px-8">
    <section>
      <h1 className="text-lg font-semibold leading-6 text-gray-900">
        Ayeface Rewards
      </h1>
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex flex-nowrap gap-1">
          <p>You have</p>
          <h2 className="text-lg font-bold leading-6 text-gray-600">
            {available_points}
          </h2>
          <p>AyeFace Points</p>
        </div>
        <button
          className="rounded-full bg-white px-5 py-2 shadow-lg"
          onClick={() => {
            navigate('/aye-face-reward')
          }}>
          <p className="bg-gradient-to-r from-[#F76443] to-[#FEC745] bg-clip-text text-transparent">
            See More
          </p>
        </button>
      </div>
    </section>
  </div>
  )
}

export default RewardPointsSection